import React, { useEffect, useRef } from 'react';
import img1 from "../../../assets/dataAnalysis.gif";
import img2 from "../../../assets/timeVertical.gif";
import img3 from "../../../assets/growth.gif";
import img4 from "../../../assets/upsellRevenue.gif";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Section2() {
  const sectionRef = useRef(null);

  const data = [
    {
      title : "State of the art solutions to increase revenue by 15% - 20% per guest",
      description : "Digitally showcase amenities and services to guests, eliminating manual barriers and enhancing accessibility. From check-in to checkout, our solution creates upsell opportunities throughout the guest's stay, while elevating the overall stay experience.",
      img : img1
    },
    {
      title: "Boost operational efficiency by 20% - 30% with smart task allocation",
      description: " Smart task allocation for routine activities frees up valuable staff time, enabling employees to focus on higher-value tasks. This leads to improved efficiency, consistent service, and reduced costs.",
      img : img2
    },
    {
      title : 'Make informed decisions with data driven insights for your hotel',
      description : "Our solution delivers actionable analytics with real-time insights into guest behavior & spendings, services & amenities utilization, and revenue & staff performance trends. Leverage this data to optimize operations, enhance guest experiences, and drive profitability.",
      img : img3
    },
    {
      title: "Gain an edge over competition in hospitality space by leveraging technology",
      description: "Stand out in the competitive hospitality industry by embracing innovative strategies. From personalized services to advanced technology, offering unique value propositions will attract more guests, enhance loyalty, and strengthen your market position.",
      img : img4
    }
  ];

  useEffect(() => {
    data.forEach((item, index) => {
      const titleElement = sectionRef.current?.querySelector(`#title-${index}`);
      const descElement = sectionRef.current?.querySelector(`#desc-${index}`);
      const imgElement = sectionRef.current?.querySelector(`#img-${index}`);

      // Title Animation
      gsap.fromTo(
        titleElement,
        {
          opacity: 0,
          y: -50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: titleElement,
            start: 'top 80%',
            end: 'top 30%',
            toggleActions: 'play none none reverse',
          }
        }
      );

      // Description Animation
      gsap.fromTo(
        descElement,
        {
          opacity: 0,
          y: 40,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.3,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: descElement,
            start: 'top 80%',
            end: 'top 30%',
            toggleActions: 'play none none reverse',
          }
        }
      );

      // Image Animation
      gsap.fromTo(
        imgElement,
        {
          opacity: 0,
          y: 40,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: imgElement,
            start: 'top 80%',
            end: 'top 30%',
            toggleActions: 'play none none reverse',
          }
        }
      );
    });
  }, []);

  return (
    <div className='mt-[60px] px-4 w-full overflow-hidden' ref={sectionRef}>
      <div className='flex flex-col gap-[30px] w-full'>
        <div className='flex flex-col gap-4'>
          {data.map((item, index) => (
            <React.Fragment key={index}>
              <div>
                <h2
                  id={`title-${index}`}
                  className='font-bold text-2xl lg:text-8xl text-[#3A3A3A]'
                  style={{ lineHeight: "38px" }}
                >
                  {item.title}
                </h2>
                <p
                  id={`desc-${index}`}
                  className='text-sm text-gray-400 mt-4'
                >
                  {item.description}
                </p>
              </div>
              <div className='w-full h-[300px]'>
                <img
                  id={`img-${index}`}
                  src={item.img}
                  className='w-full h-full object-contain'
                  alt={item.title}
                  title = {item.title}
                />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
